import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteBerichtsVorlageCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteBerichtsVorlageCommandService],
  exports: []
})
export class DeleteBerichtsVorlageCommandServiceModule { }
